import Vue from 'vue';
import { Validator } from 'vee-validate';
export default function () {
    this.jobHistoryValidation = function(){
        const dictonary = {
          custom: {
            emploType: {
              required: () => "Type is required"
            },
            company: {
              required: () => "Firm is required"
            },
            postJoin: {
              required: () => "Join Position is required"
            },
            postLeft: {
              required: () => "Last Position is required"
            },
            leaveReason: {
              required: () => "Reason to Leave is required"
            },
          }
        };
      Validator.localize('en', dictonary);
    }   
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeJobHistoryValidation.js